export const getCurrentUrl = () => window.location.href;
export const redirectToPage = url => {
  window.location.href = url;
};